import { useEditEventTypeMutation } from '@/queries/eventTypes.queries';
import { useListResourcesQuery } from '@/queries/resources.queries';
import IEventType from '@/types/IEventType';
import { useToast } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface IArgs {
	eventType: IEventType;
	participantId: string;
}

export function useParticipantItem(args: IArgs) {
	const { t } = useTranslation();
	const form = useForm({ defaultValues: { id: args.participantId } });
	const updateEventTypeMutation = useEditEventTypeMutation();
	const toast = useToast();
	const resourcesQuery = useListResourcesQuery();

	const handleRemoveClick = form.handleSubmit(() => {
		return updateEventTypeMutation
			.mutateAsync({
				...args.eventType,
				resourceRules: {
					availableInGroups: args.eventType.resourceRules?.availableInGroups || [],
					linkedResources:
						args.eventType.resourceRules?.linkedResources?.filter((r) => r.id !== args.participantId) || [],
				},
			})
			.then(() => {
				toast({ isClosable: true, title: t('Removed'), status: 'success' });
			});
	});

	return {
		resourcesQuery,
		t,
		form,
		handleRemoveClick,
	};
}
